import React from 'react'
import styled from 'styled-components'
import { Box, P, Tile, H2, IconContainer } from '@allied-solutions/affinity'
import { WarningSolid } from '@allied-solutions/affinity-react-icons/standard'

const StyledTile = styled(Tile)`
  border-radius: ${props => props.theme.radii[6]};

  & .tile-content {
    border-radius: ${props => props.theme.sizes[6]};
  }
`

export const DashboardErrorCard = () => {
  return (
    <StyledTile p="4xl">
      <StyledTile.Header>
        <Box
          as="span"
          display="flex"
          alignItems="center"
          minWidth={0}
          flex="1 1 auto"
          gap="0"
        >
          <IconContainer
            icon={WarningSolid}
            color="warning"
            backgroundColor="background.warningMuted"
            size="md"
          />
          <H2 typeStyle="titleMedium" fontWeight="700" mb="0" ml="md">
            Cannot load collateral
          </H2>
        </Box>
      </StyledTile.Header>
      <Box>
        <P typeStyle="bodyMedium.bold" mb="xs">
          Something went wrong.
        </P>
        <P
          typeStyle="labelSmall.regular"
          color="text.secondary"
          mb="0"
          maxWidth="400px"
        >
          There is an issue loading this information right now. Please check
          back later. Thank you for your patience!
        </P>
      </Box>
    </StyledTile>
  )
}
